import React from 'react'
import {Loading} from '../components'

export default function SignOutPage() {
  // NOTE: clear local storage in case gets into a buggy state
  localStorage.removeItem('session.scope')
  // using a 1s delay as a poor man's css transition
  setTimeout(() => {
    window.location.assign('/api/signout')
  }, 1000)
  return <Loading msg="Logging Out" />
}
